import { Outlet, createBrowserRouter, useLocation } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import Fleet from "./Pages/Fleet";
import CarList from "./Pages/CarList";
import EvangelList from "./Pages/EvangeList";
import Location from "./Pages/Location";
import Support from "./Pages/Support";
import AboutUS from "./Pages/AboutUs";
import { useSelector } from "react-redux";
import Booking from "./Pages/Booking";
import { LoadScript } from "@react-google-maps/api";
import NotFound from "./Pages/NotFound";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useRef, useState } from "react";
import BookingStatus from "./Pages/BookingStatus";
import ProtectedRoute from "./Pages/ProtectedRoute";
import ProfilePage from "./Pages/ProfilePage";
import TermsAndConditions from "./Pages/TermsAndConditions";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import GdprPrivacyPolicy from "./Pages/GdprPrivacyPolicy";
import RentalAgreement from "./Pages/RentalAgreement";
import CorporateRentals from "./Pages/CorporateRentals";
import Lighting from "./Pages/Lighting";
import MyTrips from "./Pages/MyTrips";
import CancelBooking from "./Pages/CancelBooking";
import Thankyou from "./Pages/Thankyou";
import SpinnerLoader from "./Components/SpinnerLoader";
import AppleLoginSuccessComponent from "./Components/AppleLoginSuccessComponent";
import Sitemap from "./Pages/Sitemap";
import VerifyEmail from "./Pages/VerifyEmail";
import ResetPassword from "./Pages/ResetPassword";
import useScrollY from "./Hooks/useScrollY";
import RentalDetailsFooter from "./Components/RentalDetailsFooter";
import TripReceiptDetails from "./Pages/TripReceiptDetails";
import whiteCloseIcon from "./assets/svg/whiteCloseIcon.svg";
import DesktopCustomModal from "./Components/DesktopCustomModal";
import axios from "axios";
import { BASE_URL } from "./api";
import { toast } from "react-toastify";
import ErrorBoundary from "./Components/ErrorBoundary";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const libraries = ["places"];

const AppLayout = () => {
  const location = useLocation();

  const currentRoute = `/${location.pathname.split("/")[1]}`;

  const userToken = useSelector(
    (store) => store?.userDetailsSlice?.userDetails?.token
  );

  const matchedReceiptRoute = "/trip-summary";

  const profileDetails = JSON.parse(
    sessionStorage?.getItem("CurrentUserDetails")
  );
  const currentPage = useSelector((state) => state?.currentPage?.page);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const scrollY = useScrollY();
  const [showDiscount, setShowDiscount] = useState(false);
  const [activeModal, setActiveModal] = useState(false);

  const [currentDiscount, setCurrentDiscount] = useState([]);
  const [discountDetails, setDiscountDetails] = useState("");
  const intervalDiscountRef = useRef(null);

  const handleLogin = (value) => {
    setIsLoggedIn(value);
  };

  const closeModal = () => {
    setActiveModal("");
    startDisplayCycle(discountDetails);
  };

  const fetchDiscountDetails = async () => {
    try {
      const result = await axios.get(`${BASE_URL}common/getDiscountCodes/open`);
      startDisplayCycle(result?.data?.data);
      setDiscountDetails(result?.data?.data);
      if (result?.data?.data?.length > 0) {
        setShowDiscount(true);
      } else {
        setShowDiscount(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  const startDisplayCycle = (data) => {
    let index = 0;
    setCurrentDiscount([data[index]]);

    intervalDiscountRef.current = setInterval(() => {
      index = (index + 1) % data?.length;
      setCurrentDiscount([data[index]]);
    }, 5000);

    // Optionally clear the interval on component unmount (cleanup)
    return () => clearInterval(intervalDiscountRef.current);
  };

  useEffect(() => {
    fetchDiscountDetails();

    return () => clearInterval(intervalDiscountRef.current);
    //eslint-disable-next-line
  }, []);

  // util function (can be inside your component or in a helper file)
  const copyToClipboard = async (text) => {
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      toast.success(`Coupon copied!`);
    } catch (err) {
      toast.error("Failed to copy coupon.");
    }
  };

  return (
    <LoadScript
      googleMapsApiKey={`${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&loading=async`} // Replace with your actual API key
      libraries={libraries} // Ensure 'places' is included in the libraries array
      loadingElement={
        <div>
          <SpinnerLoader />
        </div>
      } // Show a loading indicator
    >
      <Elements stripe={stripePromise}>
        <div>
          <div>
            {discountDetails?.length > 0 &&
              (location?.pathname === "/" ||
                location?.pathname === "/booking" ||
                location?.pathname?.split("/")[1] === "cars-list") &&
              showDiscount &&
              currentDiscount?.map((details, i) => {
                return (
                   <div key={i} className="bg321 text-white text-center discountBar p-2 fontAntarctica d-flex justify-content-center align-items-center">
                      <div>
                        <span>{details?.description}</span>
                        <span
                          onClick={() => copyToClipboard(details?.code)}
                          className="fontColorCE1 cursorPointer fontWeight700 mx-2"
                        >
                          {details?.code}
                        </span>
                        {details?.termsConditions && (
                          <span
                            className="mx-2 discountTerms"
                            onClick={() => {
                              clearInterval(intervalDiscountRef.current);
                              setActiveModal("discountModal");
                            }}
                          >
                            <span className="d-inline d-lg-none mx-0 mx-lg-2">
                              T&C
                            </span>
                          </span>
                        )}
                      </div>
                      <div className="discountCloseIcon cursorPointer px-2">
                        {details?.termsConditions && <span
                          onClick={() => {
                            clearInterval(intervalDiscountRef.current);
                            setActiveModal("discountModal");
                          }}
                          className="d-none d-lg-inline mx-2 discountTerms"
                        >
                          Terms & Conditions
                        </span>}
                        <img
                          onClick={() => setShowDiscount(!showDiscount)}
                          src={whiteCloseIcon}
                          alt="whiteCloseIcon"
                        />
                      </div>

                       {/*Discount Modal */}
                    <DesktopCustomModal
                      isModalOpen={activeModal === "discountModal"}
                      closeModal={() => closeModal("discountModal")}
                      closeOnOutsideClick={false}
                      modalCenter={true}
                      modalId="discountModal"
                      isCloseIconRequired={true}
                      modalButton=""
                      modalTitle={
                        <div className="p-3 text-center text-white fontSize17 fontAntarctica">
                          Terms & Conditions
                        </div>
                      }
                    >
                      <div className="p-2 px-3 text-white text-start fontAntarctica">
                        <p>Offers Applicable</p>
                        <p className="fontColorE0DCD3 fontSize14">
                          {details?.termsConditions}
                        </p>
                        <button
                          className="discountUnderstandBtn"
                          onClick={() => closeModal("discountModal")}
                        >
                          I Understand
                        </button>
                      </div>
                    </DesktopCustomModal>

                    </div>
                );
              })}
            {scrollY > 500 &&
            (currentPage === "home" ||
              currentPage === "showSearchContainer") ? (
              ""
            ) : currentRoute === matchedReceiptRoute &&
              (profileDetails || userToken) ? (
              ""
            ) : (
              <Navbar onLogin={handleLogin} showDiscount={showDiscount} />
            )}
          </div>
          <div className="min-vh-100">
            <ErrorBoundary>
                <Outlet context={{ isLoggedIn, showDiscount }} />
            </ErrorBoundary>
          </div>
          {currentPage === "car-list" || currentPage === "booking" ? (
            ""
          ) : currentRoute === matchedReceiptRoute && profileDetails ? (
            <RentalDetailsFooter />
          ) : (
            <Footer />
          )}
        </div>
      </Elements>
    </LoadScript>
  );
};

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/our-fleet",
        element: <Fleet />,
      },
      {
        path: "/sitemap",
        element: <Sitemap />,
      },
      {
        path: "/booking",
        element: <Booking />,
      },
      {
        path: "/trip-summary/:id",
        element: <TripReceiptDetails />,
      },
      // {
      //   path: "/trip-summary/details/:id",
      //   element: <TripReceiptDetails />,
      // },
      // {
      //   path: "/cars-list",
      //   element: <CarList />,
      // },
      {
        path: "cars-list",
        children: [
          {
            path: "", // Default route for '/cars-list'
            element: <CarList />,
          },
          {
            path: "country/:country/:location", // Match location within a country
            element: <CarList />,
          },
          {
            path: "make/:make",
            element: <CarList />,
          },
          {
            path: "*",
            element: <NotFound />, // You can use a NotFound route if necessary
          },
        ],
      },
      {
        path: "/evangelist",
        element: <EvangelList />,
      },
      {
        path: "/location",
        element: <Location />,
      },
      {
        path: "/lightningOS",
        element: <Lighting />,
      },
      {
        path: "/support",
        element: <Support />,
      },
      {
        path: "/forBusiness",
        element: <CorporateRentals />,
      },
      {
        path: "/about-us",
        element: <AboutUS />,
      },
      {
        path: "/terms-and-conditions",
        element: <TermsAndConditions />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/gdpr-privacy-policy",
        element: <GdprPrivacyPolicy />,
      },
      {
        path: "/rental-agreement",
        element: <RentalAgreement />,
      },
      {
        path: "/apple-login-success",
        element: <AppleLoginSuccessComponent />,
      },
      {
        path: "/verify-email",
        element: <VerifyEmail />,
      },
      {
        path: "/reset-password",
        element: <ResetPassword />,
      },
      {
        path: "/thankyou",
        element: (
          <ProtectedRoute>
            <Thankyou />
          </ProtectedRoute>
        ),
      },
      {
        path: "/user-profile",
        element: (
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/booking-status",
        element: (
          <ProtectedRoute>
            <BookingStatus />
          </ProtectedRoute>
        ),
      },
      {
        path: "/booking-history",
        element: (
          <ProtectedRoute>
            <MyTrips />
          </ProtectedRoute>
        ),
      },
      {
        path: "/cancel-booking",
        element: (
          <ProtectedRoute>
            <CancelBooking />
          </ProtectedRoute>
        ),
      },
      {
        path: "/faqs",
        element: <Home />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

export default appRouter;
